module.exports = __webpack_public_path__ + "static/media/instagram.50ffad94.svg";